import React, { CSSProperties } from 'react';

import Clickable from 'ds/Clickable';
import Icon from 'ds/Icon';
import Layout from 'ds/Layout';
import Text from 'ds/Text';
import { GRAY_25_HEX } from 'shared';

interface Props {
  onClick: VoidFunction;
  style?: CSSProperties;
  filename: string;
  filesize?: number;
  showDownloadIcon?: boolean;
}

const MessagePdfThumbnail: React.FC<Props> = ({ onClick, style, filename, filesize, showDownloadIcon = true }) => {
  const formatFileSize = (bytes?: number) => {
    if (!bytes) return '';
    const mb = bytes / (1024 * 1024);
    return `${mb.toFixed(1)} MB`;
  };

  return (
    <Clickable onClick={onClick} style={{ ...style, backgroundColor: `${GRAY_25_HEX}`, borderRadius: 8 }}>
      <Layout
        direction="row"
        gap={8}
        align="center"
        paddingLeft={8}
        paddingRight={12}
        paddingY={8}
        style={{
          ...style,
          height: 'auto'
        }}
      >
        {/* PDF Icon */}
        <Layout
          align="center"
          justify="center"
          width={32}
          height={32}
          minWidth={32}
          minHeight={32}
          borderRadius={8}
          color="red-500"
        >
          <Icon name="page" size="xxs" color="white" />
        </Layout>

        {/* File Info */}
        <Layout direction="column" align="flex-start">
          <Layout width={186}>
            <Text size="body-xs" semibold ellipsis align="left">
              {filename}
            </Text>
          </Layout>
          <Text size="tag" color="gray-400">
            PDF • {formatFileSize(filesize)}
          </Text>
        </Layout>

        {showDownloadIcon && <Icon name="download" size="sm" />}
      </Layout>
    </Clickable>
  );
};

export default MessagePdfThumbnail;
